import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import PlaylistsSharedModal from './PlaylistsSharedModal.jsx';

const PlaylistTitleBurger = ({ id, name, shared, shared_link, count, onDeleteClick, onEditModeOn }) => {

  const handleDelete = () => onDeleteClick();
  const handleEditModeOn = () => onEditModeOn(true);

  return (
     <Dropdown>
       <Dropdown.Toggle variant="light" id={ `dropdown-basic-${id}` } className='menu-burger'>
         <i className="icon icon-menu"></i>
       </Dropdown.Toggle>
       <Dropdown.Menu>
         { count > 0 && <PlaylistsSharedModal id={ id }
                                              name={ name }
                                              shared={ shared }
                                              shared_link={ shared_link }/> }
         <Dropdown.Item as="button" onClick={ handleEditModeOn }>
           { gettext('Изменить название') }
         </Dropdown.Item>
         <Dropdown.Item as="button" onClick={ handleDelete }>
           { gettext('Удалить плейлист') }
         </Dropdown.Item>
       </Dropdown.Menu>
     </Dropdown>
  )
}

PlaylistTitleBurger.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  shared: PropTypes.bool.isRequired,
  shared_link: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onEditModeOn: PropTypes.func.isRequired,
}

export default PlaylistTitleBurger;

